module.exports = __webpack_public_path__ + "static/media/Group_1597880868@2x.60c2eaaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1597880868@2x.png
// module id = 1748
// module chunks = 0